module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU5Ni40IDUxMmMwIDQ2LjYtMzcuOCA4NC40LTg0LjQgODQuNC00Ni42IDAtODQuNC0zNy44LTg0LjQtODQuNCAwLTQ2LjYgMzcuOC04NC40IDg0LjQtODQuNEM1NTguNiA0MjcuNiA1OTYuNCA0NjUuNCA1OTYuNCA1MTJ6IiBmaWxsPSIjMjMxODE1IiBwLWlkPSI2MzkiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/di.svg
// module id = XjFp
// module chunks = 74